export const formPayData = {
  title: 'onlyne_pay'
};

export const formVerifyData = {
  title: 'comfirm_your_card'
};
